import { Mobile } from '../core'

$.fn.parallax = function(speed = .5, breakpoints = 'both') {
  let self = this
  self.mobileChecker = new Mobile()
  self.wrap('<div class="parallax-wrapper"></div>')
  let wrapper = self.closest('.parallax-wrapper')

  /* Status */
  let repaint = true
  let buffer = false

  /* Reset transform */
  self.reset = function() {
    self.css({
      transform: '',
    })
  }

  self.parallax = function() {
    if (breakpoints != 'both' &&
    ((breakpoints == 'desktop' && $.mlmi.mobile.isMobile) ||
    (breakpoints == 'mobile' && !$.mlmi.mobile.isMobile))) {
      return self;
    }
    const objectCenter = wrapper.offset().top + (wrapper.height() / 2) - ($(window).height() / 2)
    let translate = (objectCenter - $(window).scrollTop()) * speed

    self.css({transform: `translate3d(0, ${-translate}px, 0)`,})

    /* Keep paint status */
    repaint = true
    if (buffer) {
      buffer = false
      self.parallax()
    }
  }

  /* Scroll handler */
  self.scrolled = function() {
    if ((breakpoints == 'desktop' && self.mobileChecker.isMobile) || breakpoints == 'mobile' && !self.mobileChecker.isMobile) {
      self.reset()
    } else if (repaint) {
      repaint = false
      window.requestAnimationFrame(self.parallax)
    } else {
      buffer = true
    }
  }

  /* Kill */
  self.kill = function() {
    self.mobileChecker.kill()
    $(window).off('scroll resize orientationchange load', self.scrolled)
  }

  return function() {
    $(window).on('scroll resize orientationchange load', self.scrolled)
    return self;
  }();
};
